module.exports = __webpack_public_path__ + "media/notices/Repeción de SRC-3-f477df2f.jpg";